import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useAuth } from '../contexts/AuthContext';

/**
 * Layout component that provides the main application structure
 * 
 * @param {React.ReactNode} children - The content to render in the main area
 * @param {boolean} sidebarCollapsed - Whether the sidebar is collapsed
 * @param {function} toggleSidebar - Function to toggle sidebar collapsed state
 */
const Layout = ({ children, sidebarCollapsed, toggleSidebar }) => {
  const { user } = useAuth();
  // Track the actual expanded state, which could be due to hover or manual toggle
  const [sidebarExpanded, setSidebarExpanded] = useState(!sidebarCollapsed);
  
  // Update expanded state when collapsed state changes from parent
  useEffect(() => {
    setSidebarExpanded(!sidebarCollapsed);
  }, [sidebarCollapsed]);
  
  // Determine sidebar width based on actual expansion state
  const sidebarWidth = sidebarExpanded ? '282px' : '70px';
  
  return (
    <div className="flex h-screen">
      {/* Sidebar component - positioned with proper z-index */}
      <div className="transition-all duration-300 ease-in-out" style={{ width: sidebarWidth, flexShrink: 0 }}>
        <Sidebar
          collapsed={sidebarCollapsed}
          toggleSidebar={toggleSidebar}
          onHoverLeave={() => {}}
          onExpandChange={(expanded) => setSidebarExpanded(expanded)}
        />
      </div>
      
      {/* Main content - transitions with sidebar width */}
      <div className="transition-all duration-300 ease-in-out flex-1 flex flex-col overflow-hidden">
        <Header 
          sidebarCollapsed={sidebarCollapsed} 
          toggleSidebar={toggleSidebar} 
        />
        
        <main className="flex-1 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout; 